import { useEffect } from "react";
import { useUser, useClerk } from "@clerk/clerk-react";
import { useToast } from "@/hooks/use-toast";

interface SuperAdminAuthWrapperProps {
  children: React.ReactNode;
}

export const SuperAdminAuthWrapper = ({ children }: SuperAdminAuthWrapperProps) => {
  const { user, isLoaded } = useUser();
  const { signOut } = useClerk();
  const { toast } = useToast();

  useEffect(() => {
    if (isLoaded && user) {
      // Check if user has superAdmin flag in public metadata
      const isSuperAdmin = user.publicMetadata?.superAdmin === true || user.publicMetadata?.superAdmin === "true";
      
      if (!isSuperAdmin) {
        // Show toast message
        toast({
          title: "Access Denied",
          description: "User not found. Please contact your administrator.",
          variant: "destructive",
        });
        
        // Sign out the user
        signOut();
        return;
      }
    }
  }, [isLoaded, user, signOut, toast]);

  // If user is loaded and is not a superAdmin, don't render children
  if (isLoaded && user) {
    const isSuperAdmin = user.publicMetadata?.superAdmin === true || user.publicMetadata?.superAdmin === "true";
    if (!isSuperAdmin) {
      return null; // Don't render anything while signing out
    }
  }

  return <>{children}</>;
};